import _slicedToArray from "/home/ranuser/Downloads/netfersmartsolutions-mrxfrontend-1d22252a1abf/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["sortingOrder"];
import * as React from 'react';
import { useGridRootProps } from '../../hooks/utils/useGridRootProps';
import { jsx as _jsx } from "react/jsx-runtime";
export var GridColumnUnsortedIcon =
/*#__PURE__*/
React.memo(function GridColumnHeaderSortIcon(props) {
  var sortingOrder = props.sortingOrder,
      other = _objectWithoutPropertiesLoose(props, _excluded);

  var rootProps = useGridRootProps();

  var _sortingOrder = _slicedToArray(sortingOrder, 1),
      nextSortDirection = _sortingOrder[0];

  var Icon = nextSortDirection === 'asc' ? rootProps.slots.columnSortedAscendingIcon : rootProps.slots.columnSortedDescendingIcon;
  return Icon ?
  /*#__PURE__*/
  _jsx(Icon, _extends({}, other)) : null;
});